import React from 'react';
import PropTypes from 'prop-types';
import {browserHistory} from 'react-router';
import ArrowDownwardIcon from 'material-ui/svg-icons/navigation/arrow-downward';
import ArrowUpwardIcon from 'material-ui/svg-icons/navigation/arrow-upward';
import './KeyMetric.styl';

export default class KeyMetric extends React.PureComponent {
  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick() {
    const {adminId, path} = this.props;
    const params = {adminId};
    browserHistory.push(path(params));
  }

  getArrow(current, previous) {
    // precise match, this class does not do rounding
    // if rounding is needed, round them before passing to this component
    if (current === previous) {
      return <div className="tie">|</div>;
    }
    return (previous == null && current != null) || (current != null && current > previous) ? (
      <ArrowUpwardIcon className="arrow up" />
    ) : (
      <ArrowDownwardIcon className="arrow down" />
    );
  }

  render() {
    const {label, current, previous, valueFormatter, isNewAccount, newAccountValue} = this.props;
    return (
      <div className="key-metric" onClick={this.onClick}>
        {!isNewAccount && (
          <div className="numbers">
            <div className="current">{valueFormatter ? valueFormatter(current) : current}</div>
            {this.getArrow(current, previous)}
            <div className="previous">{valueFormatter ? valueFormatter(previous) : previous}</div>
          </div>
        )}
        {isNewAccount && (
          <div className="numbers">
            <div className="previous">{newAccountValue}</div>
          </div>
        )}
        <div className="label">{label}</div>
      </div>
    );
  }
}

KeyMetric.propTypes = {
  adminId: PropTypes.string,
  path: PropTypes.func,
  label: PropTypes.string,
  current: PropTypes.number,
  previous: PropTypes.number,
  valueFormatter: PropTypes.func,
};
